export default "__VITE_ASSET__98e85d94__"